import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";

interface AssessmentState {
  id: string | undefined;
  completeModalOpen: boolean;
}

const initialState: AssessmentState = {
  id: undefined,
  completeModalOpen: false,
};

const assessmentsSlice = createSlice({
  name: "assessment",
  initialState,
  reducers: {
    initialize(state, action: PayloadAction<string>) {
      return { ...initialState, id: action.payload };
    },
    setCompleteModalOpen(state, action: PayloadAction<boolean>) {
      state.completeModalOpen = action.payload;
    },
  },
});

export const assessmentReducer = assessmentsSlice.reducer;
export const { setCompleteModalOpen, initialize } = assessmentsSlice.actions;
